import { useTranslation } from 'react-i18next';
import { HEARD_ABOUT_CHOICES, HEARD_ABOUT_DETAIL_LIMIT, type HeardAboutChoice } from '@shared/heard-about.ts';
import { Select, TextInput } from './ui.tsx';

/**
 * The optional "How did you hear about us?" question. Nothing is preselected,
 * and submitting with the blank choice is a complete answer.
 */
export default function HeardAboutField({
  choice,
  detail,
  onChoice,
  onDetail,
}: {
  choice: HeardAboutChoice | '';
  detail: string;
  onChoice: (choice: HeardAboutChoice | '') => void;
  onDetail: (detail: string) => void;
}) {
  const { t } = useTranslation();
  const options = [
    { value: '', label: t('auth.heardAbout.placeholder') },
    ...HEARD_ABOUT_CHOICES.map((value) => ({ value, label: t(`auth.heardAbout.choices.${value}`) })),
  ];

  return (
    <>
      <Select
        label={t('auth.heardAbout.label')}
        name="heardAbout"
        hint={t('auth.heardAbout.hint')}
        options={options}
        value={choice}
        onChange={(event) => {
          const next = event.target.value;
          onChoice(next === '' ? '' : (next as HeardAboutChoice));
          if (next !== 'other') onDetail('');
        }}
      />
      {choice === 'other' ? (
        <TextInput
          label={t('auth.heardAbout.detailLabel')}
          name="heardAboutDetail"
          hint={t('auth.heardAbout.detailHint')}
          maxLength={HEARD_ABOUT_DETAIL_LIMIT}
          value={detail}
          onChange={(event) => onDetail(event.target.value)}
        />
      ) : null}
    </>
  );
}
